// src/directives/selectLoadMore.ts
import { type DirectiveBinding, nextTick } from 'vue';

// 扩展HTMLElement接口
interface ExtendedHTMLElement extends HTMLElement {
    _scrollHandler?: (e:any) => void;
    _observer?: MutationObserver;
}

export const selectLoadMore = {
    mounted(
        el: ExtendedHTMLElement,
        binding: DirectiveBinding<() => void>
    ): void {
        // 直接在 document 上监听滚动事件，但只处理特定条件下的滚动
        const handler = debounce((e: Event) => {
            // 检查滚动事件是否发生在 el-select 的下拉框中
            
            const target = e.target as HTMLElement;
            if (!target.closest('.el-select-dropdown')) return;
            
            
            // 确认是滚动容器元素
            // const isScrollWrap =
            //     target.matches('.el-select-dropdown__wrap') ||
            //     target.matches('.el-scrollbar__wrap');
            // if (!isScrollWrap) return;

            const scrollWrap = target;
            const scrollDistance =
                scrollWrap.scrollHeight -
                scrollWrap.scrollTop -
                scrollWrap.clientHeight;
            
            
            if (scrollDistance <= 50) {
                binding.value();
            }
        }, 150);

        document.addEventListener('scroll', handler, true); // 使用捕获阶段

        el._scrollHandler = handler;
    },

    beforeUnmount(el: ExtendedHTMLElement): void {
        if (el._scrollHandler) {
            document.removeEventListener('scroll', el._scrollHandler, true);
        }
    },
};

function debounce<T extends (...args: any[]) => any>(
    func: T,
    wait: number
): (...args: Parameters<T>) => void {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return function executedFunction(...args: Parameters<T>): void {
        const later = () => {
            timeout = null;
            func(...args);
        };

        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
    };
}
